import { Tag } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function ChangelogHeader({
  version,
  date,
  tag,
}: {
  version: string;
  date: string;
  tag?: string;
}) {
  return (
    <div className="not-prose mb-6">
      <Card className="border-border/70 bg-card">
        <CardContent className="flex flex-wrap items-center gap-2 px-4 py-3">
          <Badge
            variant="outline"
            className="gap-1 border-primary/40 bg-primary/10 text-primary"
          >
            <Tag className="h-3 w-3" />v{version}
          </Badge>
          {tag && <Badge variant="secondary">{tag}</Badge>}
          <span className="text-[11px] text-muted-foreground">{date}</span>
        </CardContent>
      </Card>
    </div>
  );
}
